<template>
  <div data-test="benefits" class="main-features py-6 m:py-8 l:py-12 l:pb-0">
    <div class="main-features__container container">
      <div class="grid">
        <h2 class="main-features__headline grid__el--xs-12">
          {{ headline }}
        </h2>
      </div>

      <div class="main-features__features grid">
        <div
          class="main-features__feature grid__el--xs-12 grid__el--m-4"
          v-for="feature in $t('features.mainFeaturesSection.benefits.features')"
          :key="feature.headline"
        >
          <main-feature :feature="feature" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainFeature from "@/features/main-features-section/main-feature"

export default {
  name: "MainFeaturesBenefits",
  components: {
    MainFeature
  },
  props: {
    signupRoute: {
      type: String,
      required: false,
      default: null
    },
    showTrialEndDate: {
      type: Boolean,
      default: false
    },
    headlineVariation: {
      type: String,
      default: "headline"
    }
  },
  computed: {
    headline() {
      return this.$t(`features.mainFeaturesSection.benefits.${this.headlineVariation}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.main-features {
  &__headline {
    @include font-style(
      (
        xs: h3,
        m: h2
      )
    );

    text-align: center;
  }

  &__features {
    margin-bottom: $spacing-32;

    @include media(min-width, m) {
      margin-bottom: $spacing-48;
    }
  }

  &__feature {
    &:not(:last-child) {
      margin-bottom: $spacing-24;
    }
  }
}
</style>
